import { createContext, useContext } from "react";

/** Background lightness of a scene, so the fixed chrome (header, pager) can flip to stay legible. */
export type SceneTone = "light" | "dark";

export interface SceneMeta {
  id: string;
  /** Short name for the section pager and its screen-reader label. */
  label: string;
  tone: SceneTone;
}

export interface StageValue {
  /** The scene the page has come to rest on, or null before the first measurement. */
  arrivedId: string | null;
  /** Registered scenes in document order. */
  scenes: SceneMeta[];
  /** Called by <Scene> on mount; returns the unregister function. */
  register: (meta: SceneMeta, el: HTMLElement) => () => void;
  /** Scroll a scene into place (it then arrives like any other scroll). */
  goTo: (id: string) => void;
}

export const StageContext = createContext<StageValue | null>(null);

export function useStage(): StageValue {
  const stage = useContext(StageContext);
  if (!stage) throw new Error("useStage() must be used inside <SnapStage>");
  return stage;
}
